import React from 'react'
import PropTypes from 'prop-types'
import { Container, Form } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';

// Helper to show Popup Confirmation Alert to the users.
// It let us use to show a simple message with confirm/cancellation action, and one way to more secure user action 
// avoiding mistake (for this control, this helper provide a "code validation" field)
export const helperConfirmationAlert = (
        context, // Context to transalate with redux-i18n
        title = "Confirm action", // Title of the popup
        message = "Confirm action", // Main message to the user
        okLabel = "Ok", // Label of the confirmation button
        notOkLabel = "Cancel", // Label of the cancelation button
        onClickOk = () => true, // Function to call after click on confirmation button
        onClickNotOk = () => true, // Function to call after click on cancelation button
        keyWordConfirmation = null, // This attribute defines if the popup must ask a "keyword" to the user in order to secure confirm user action avoid user mistake.
        ) => {
            
    // Return a confirmation key word when is necesary a double confirmation by the user.
    // To use this funcitonality, it must set a value in "keyWordConfirmation" attribute.
    const hasVerificationCode = () => {
        return (keyWordConfirmation)?
                    <Container>
                        <br/>
                        <Form.Group controlId={"keywordEntered"}>
                            {context.t("Type '{value}' to confirm", {value: keyWordConfirmation })}
                            <Form.Control name="keywordEntered" type="text" autoComplete="off"/>
                            {/* Hidden by default in order to show when isn't validated correctly through validateCode() funciton */}
                            <p id="errorId" className='error-message m-0 text-center d-none'>
                                {context.t("Invalid value")}
                            </p>
                            </Form.Group> 
                    </Container>
                : 
                <></>;
    }

    // This function is called from onClick button of "confirmation button" in "confirmAlert()" function in order to control and validate the user is controlling the confirmation action.
    const validateCode = () => {
        const textField = document.getElementById("keywordEntered");
        var userCodeOk = textField.value === keyWordConfirmation;
        //  When "keyWordConfirmation" attribute exists, we check if is identical than entered bye the user.
        if (userCodeOk) {
            // After user control, we execute recived function.
            return onClickOk();
        } else {            
            document.getElementById("errorId").classList.remove('d-none'); // Remove style attribute than makes "error" hidden by default.
            textField.focus();
            throw 'Entered code is not valid'; // Throws an exception in order to interrupt javascript execution into the onClick event process (return "false" doesn't work).
        }

    }

    // Display confirmAlert component.
    confirmAlert({       
        title: title,
        message: message,
        childrenElement: () => hasVerificationCode(),
        overlayClassName: "outline-primary",
        buttons: [
            {
                label: notOkLabel,
                onClick: onClickNotOk,
            },
            {
                label: okLabel,
                onClick: (keyWordConfirmation)? () => validateCode() : () => onClickOk(), 
            }
        ],
        closeOnClickOutside: false,
    })
}

helperConfirmationAlert.contextTypes = {
    t: PropTypes.func.isRequired
}

helperConfirmationAlert.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
}
